module.exports = __webpack_public_path__ + "static/img/ikonaPaintDisabled-OFF.a4e622bf.png";